import { createSlice } from '@reduxjs/toolkit';
import _ from '@lodash';
import { setInitialSettings, setDefaultSettings } from 'app/store/fuse/settingsSlice';
import { showMessage } from 'app/store/fuse/messageSlice';
import jwtService from 'app/services/jwtService';

// Store a reference to the navigate function for use outside components
let _navigate = null;
export const setNavigateRef = (navigateFn) => { _navigate = navigateFn; };

export const setUserTokenData = user => async (dispatch, getState) => {
	dispatch(setUser(user));
};

export const setUserData = user => async (dispatch, getState) => {
	// Store redirect URL for later use
	window.__redirectUrl = "adm/companies";
	dispatch(setDefaultSettings(user.data.settings));
	dispatch(setUser(user));
};

export const updateUserSettings = settings => async (dispatch, getState) => {
	const oldUser = getState().auth.user;
	const user = _.merge({}, oldUser, { data: { settings } });

	dispatch(updateUserData(user));

	return dispatch(setUserData(user));
};

export const updateUserShortcuts = shortcuts => async (dispatch, getState) => {
	const { user } = getState().auth;
	const newUser = {
		...user,
		data: {
			...user.data,
			shortcuts
		}
	};

	dispatch(updateUserData(user));

	return dispatch(setUserData(newUser));
};

export const logoutUser = () => async (dispatch, getState) => {
	const { user } = getState().auth;

	if (!user.role || user.role.length === 0) {
		// is guest
		return null;
	}

	if (_navigate) {
		_navigate('/');
	} else {
		window.location.href = '/';
	}

	jwtService.logout();

	dispatch(setInitialSettings());

	return dispatch(userLoggedOut());
};

export const updateUserData = user => async (dispatch, getState) => {
	if (!user.role || user.role.length === 0) {
		// is guest
		return;
	}
	jwtService
		.updateUserData(user)
		.then(() => {
			dispatch(showMessage({ message: 'User data saved with api' }));
		})
		.catch(error => {
			dispatch(showMessage({ message: error.message }));
		});
};

const token = jwtService.getAccessTokenDecoded();

const initialState = token ? {
	role: [], // guest
	data: {
		displayName: token ? token.name : "",
		photoURL: token ? 'assets/images/avatars/profile.jpg' : "",
		email: token ? token.email : "",
		shortcuts: ['calendar', 'mail', 'contacts', 'todo'],
		companyId: token.companyId,
		exp: token.exp,
		iat: token.iat,
		role: token.role,
		userHash: token.userHash,
		userId: token.userId,
		accountType: token.accountType,
		nameContact: token.nameContact,
		emailContact: token.emailContact,
		position: token.position,
		phoneNumberContact: token.phoneNumberContact,
		nameCompany: token.nameCompany,
		identityCompany: token.identityCompany,
		legalRepresentativeCompany: token.legalRepresentativeCompany,
		companyRole: token.companyRole,
		isActor: token.isActor
	}
} : {
	role: [], // guest
	data: {
		displayName: "",
		photoURL: "",
		email: "",
		shortcuts: ['calendar', 'mail', 'contacts', 'todo'],
	}
};


const userSlice = createSlice({
	name: 'auth/user',
	initialState,
	reducers: {
		setUser: (state, action) => action.payload,
		userLoggedOut: (state, action) => initialState
	},
});

export const { setUser, userLoggedOut } = userSlice.actions;

export default userSlice.reducer;
